(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('[data-slider-section]');
  if (!section) return;

  const track = section.querySelector('.custom-slider-track');
  const slides = Array.from(track.querySelectorAll('.custom-slide'));
  const prevBtn = section.querySelector('.slider-prev');
  const nextBtn = section.querySelector('.slider-next');
  const dotsContainer = section.querySelector('.slider-dots');

  let index = 0;
  const total = slides.length;

  // Build dots
  function buildDots() {
    dotsContainer.innerHTML = '';
    for (let i=0; i<total; i++) {
      const btn = document.createElement('button');
      btn.setAttribute('aria-label', 'Go to slide ' + (i+1));
      btn.dataset.slide = i;
      btn.addEventListener('click', () => goToSlide(i));
      dotsContainer.appendChild(btn);
    }
    updateDots();
  }

  function updateDots() {
    const dots = Array.from(dotsContainer.children);
    dots.forEach((d, i) => d.classList.toggle('active', i === index));
  }

  function setPosition() {
    const w = track.clientWidth; // width of viewport container (each slide is 100%)
    track.style.transform = `translateX(-${index * 100}%)`;
    updateAria();
    updateDots();
  }

  function updateAria() {
    slides.forEach((s, i) => {
      s.setAttribute('aria-hidden', i !== index);
      s.tabIndex = i === index ? 0 : -1;
    });
  }

  function prev() {
    index = (index - 1 + total) % total;
    setPosition();
  }
  function next() {
    index = (index + 1) % total;
    setPosition();
  }
  function goToSlide(i) {
    index = Math.max(0, Math.min(i, total-1));
    setPosition();
  }

  // Touch / drag support
  let startX = 0, currentX = 0, isDown = false;
  track.addEventListener('pointerdown', function(e) {
    isDown = true;
    startX = e.clientX;
    track.style.transition = 'none';
    track.setPointerCapture(e.pointerId);
  });
  track.addEventListener('pointermove', function(e) {
    if (!isDown) return;
    currentX = e.clientX;
    const dx = currentX - startX;
    // visually move track a bit
    track.style.transform = `translateX(calc(-${index * 100}% + ${dx}px))`;
  });
  track.addEventListener('pointerup', function(e) {
    if (!isDown) return;
    isDown = false;
    track.style.transition = '';
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 60) {
      if (dx < 0) next(); else prev();
    } else {
      setPosition();
    }
    try { track.releasePointerCapture(e.pointerId); } catch (err) {}
  });
  track.addEventListener('pointercancel', function(e){
    isDown = false;
    track.style.transition = '';
    setPosition();
  });

  // Keyboard controls for accessibility
  section.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });

  // Button events
  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);

  // Resize handler (in case images change layout)
  window.addEventListener('resize', function () {
    setPosition();
  });

  // Init
  if (total <= 1) {
    // hide arrows & dots
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    dotsContainer.style.display = 'none';
  } else {
    buildDots();
  }
  // Ensure first slide aria
  updateAria();
  setPosition();

  // If theme editor changes blocks (section re-render), Shopify sometimes re-inserts section.
  // Provide a simple mutation observer to re-init if needed.
  const mo = new MutationObserver(function(mutations) {
    // If number of slides changed, reload the page to be safe (simple approach)
    const currentSlides = track.querySelectorAll('.custom-slide').length;
    if (currentSlides !== total) {
      window.location.reload();
    }
  });
  mo.observe(track, { childList: true, subtree: false });

})();

  } catch(e) { console.error(e); }
})();
})();
